export const BANK_MASKS: Record<string, { ag: string; cc: string }> = {
  '001': { ag: '0000-0?', cc: 'AAAAAAAA-A' }, // Banco do Brasil
  '033': { ag: '0000', cc: '000000000-0' }, // Santander
  '104': { ag: '0000', cc: '000000000000-0' }, // Caixa Econômica (simplificado)
  '237': { ag: '0000-0?', cc: '0000000-0' }, // Bradesco / Next
  '341': { ag: '0000', cc: '000000000-0' }, // Itaú
  '121': { ag: '0000', cc: '0000000000' }, // Agibank (sem dígito)
  '037': { ag: '0000', cc: '000000000-0' }, // Banpará
  '041': { ag: '0000', cc: '000000000-0' }, // Banrisul
  '748': { ag: '0000', cc: '000000000' }, // Sicredi
  '756': { ag: '0000', cc: '000000000-0' }, // Sicoob
  '077': { ag: '0000', cc: '000000000-0' }, // Inter
  '070': { ag: '0000', cc: '000000000-0' }, // BRB
  '085': { ag: '0000', cc: '00000000000-0' }, // Via Credi (cooperativa)
  '655': { ag: '0000', cc: '000000000-0' }, // Neon/Votorantim
  '260': { ag: '0000', cc: '0000000000-0' }, // Nubank
  '290': { ag: '0000', cc: '00000000-0' }, // Pagseguro
  '212': { ag: '0000', cc: '0000000-0' }, // Banco Original
  '422': { ag: '0000', cc: '00000000-0' }, // Safra
  '746': { ag: '0000', cc: '000000000-0' }, // Modal
  '021': { ag: '0000', cc: '00000000-0' }, // Banestes
  '136': { ag: '0000', cc: '00000000-0' }, // Unicred
  '274': { ag: '0000', cc: '00000000-0' }, // Money Plus
  '389': { ag: '0000', cc: '00000000-0' }, // Mercantil do Brasil
  '376': { ag: '0000', cc: '00000000000-0' }, // JP Morgan (ajuste por 999)
  '364': { ag: '0000', cc: '00000000-0' }, // Gerencianet
  '336': { ag: '0000', cc: '00000000-0' }, // Banco C6
  '218': { ag: '0000', cc: '000000000-0' }, // BS2
  '082': { ag: '0000', cc: '0000000-0' }, // Banco Topazio
  '099': { ag: '0000', cc: '000000-0' }, // Uniprime (6 dígitos + dígito)
  '197': { ag: '0000', cc: '0000000-0' }, // Stone
  '707': { ag: '0000', cc: '0000000-0' }, // Daycoval
  '633': { ag: '0000-0?', cc: '0000000000' }, // Rendimento (ag. com dígito)
  '004': { ag: '000-0?', cc: '000000-0' }, // Banco do Nordeste (003 dígitos ag.)
  '745': { ag: '0000', cc: '00000000' }, // Citibank (sem dígito de conta)
  '301': { ag: '0000', cc: '0000000000-0' }, // PJBank
  '097': { ag: '0000', cc: '0000000-0' }, // Cooperativa Noroeste
  '084': { ag: '0000', cc: '000000-0' }, // Uniprime Norte do Paraná
  '384': { ag: '0000', cc: '000000000-0' }, // Global SCM
  '403': { ag: '0000', cc: '00000000-0' }, // Cora
  '323': { ag: '0000', cc: '0000000000-0' }, // Mercado Pago
  '003': { ag: '0000', cc: '000000-0' }, // Banco da Amazônia
  '752': { ag: '0000', cc: '000000-000' }, // BNP Paribas Brasil
  '383': { ag: '0000', cc: '0000000000-0' }, // Juno
  '133': { ag: '0000', cc: '00000000-0' }, // Cresol
  '173': { ag: '0000', cc: '000000-0' }, // BRL Trust DTVM
  '047': { ag: '0000', cc: '00000000-0' }, // Banco Banese
  '208': { ag: '0000', cc: '0000000-0' }, // BTG Pactual
  '613': { ag: '0000', cc: '000000-0' }, // Banco Omni
  '332': { ag: '0000', cc: '000000000-0' }, // Acesso Soluções
  '273': { ag: '0000', cc: '00000' }, // CCR MG do Oeste (ajuste manual)
  '093': { ag: '0000', cc: '000000-0' }, // Polocred
  '355': { ag: '0000', cc: '00000-0' }, // Ótimo (nove ou cinco dígitos)
  '125': { ag: '0000', cc: '0000-0' }, // Genial (conta curta com dígito)
  '412': { ag: '0000', cc: '000000000' }, // Banco Capital
  '741': { ag: '00000', cc: '0000000000' }, // Ribeirão Preto (agência 5 dígitos)
  '461': { ag: '0000', cc: '0000000-0' }, // ASAAS IP
  '623': { ag: '0000', cc: '000000000-0' }, // Banco Pan
  '735': { ag: '0000', cc: '0000000000-0' }, // Neon Pagamentos
  '310': { ag: '0000-0?', cc: '000-0' }, // VORTX DTVM LTDA
  '318': { ag: '0000', cc: '00000000' }, // Banco BMG
  '450': { ag: '0000', cc: '000000000-9' }, // Fitbank (conta com formato varia)
  '174': { ag: '0000', cc: '0000000-0' }, // Pefisa
  '451': { ag: '0000', cc: '0000000000-0' }, // J17
  '089': { ag: '0000', cc: '000000000-0' }, // Credisan
};
